module.exports = __webpack_public_path__ + "static/Roboto-MediumItalic-c1d8fbd29929d048c8d065d1be3bc35d.ttf";